import { render } from "./BookingTourGuideForm.vue?vue&type=template&id=8ba1f342&scoped=true"
import script from "./BookingTourGuideForm.vue?vue&type=script&lang=js"
export * from "./BookingTourGuideForm.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8ba1f342"

export default script